import { RouteObject } from "react-router-dom";

import ProtectedRoute from "../Routes/ProtectedRoute";
import { PredefinedWord } from "../Routes/Predefined";
import { ROUTES } from "../Routes/routes";

import CentralManagerHubLayout from "../layouts/CentralManagerHubLayout";
import DashboardManagerCentralHub from "../components/CentralHub/Manager/DashboardManagerCentralHub";
import ManagerProfile from "../components/CentralHub/Manager/ManagerProfile";
import CancelOrder from "../components/CentralHub/Manager/CancelOrder";
import ManagerScheduledOrders from "../components/CentralHub/Manager/ManagerScheduleOrders";
import DeliveryPartner from "../components/CentralHub/Manager/DeliveryPartner";
import CompleteOrder from "../components/CentralHub/Manager/CompletedOrders";
import ManagerReport from "../components/CentralHub/Manager/ManagerReport";
import ChangePassword from "../layouts/ChangePassword";
import ManagerDesignerPerformance from "../components/CentralHub/Manager/ManagerDesignerPerformance";
import ManagerMillingPerformance from "../components/CentralHub/Manager/ManagerMillingPerformance";
import ManagerDispatchOverview from "../components/CentralHub/Manager/ManagerDispatchOverview";
import ManagerstlPreview from "../components/CentralHub/Manager/ManagerstlPreview";
import ManagerMillingResourceOverview from "../components/CentralHub/Manager/ManagerMillingResourceOverview";
import ManagerRejectedOrder from "../components/CentralHub/Manager/ManagerRejectedOrder";
import ReplyRaiseTicket from "../components/CentralHub/Manager/Ticket";
import ManagerSLABreachMonitor from "../components/CentralHub/Manager/ManagerSLABreachMonitor";
import ManagerContactSupport from "../components/CentralHub/Manager/ManagerContactSupport";
import RealtimeOrderTracking from "../components/CentralHub/Manager/RealtimeOrderTracking";
import ManagerWarrantyClaimResponse from "../components/CentralHub/Manager/ManagerWarrantyClaimResponse";

export const managerRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute
        allowedRoles={[PredefinedWord.Roles.CENTRAL.MANAGER]}
      />
    ),
    children: [
      {
        element: <CentralManagerHubLayout />,
        children: [
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_DashboardManagerCentralHub,
            element: <DashboardManagerCentralHub />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_ManagerProfile,
            element: <ManagerProfile />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_CancelOrder,
            element: <CancelOrder />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_ManagerScheduledOrders,
            element: <ManagerScheduledOrders />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_DeliveryPartner,
            element: <DeliveryPartner />,
          },
          {
            path: ROUTES.CENTRAL.Manager.CompleteOrder,
            element: <CompleteOrder />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_ManagerReport,
            element: <ManagerReport />,
          },
          {
            path: ROUTES.CENTRAL.Manager.ChangePassword,
            element: <ChangePassword />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_ManagerDesignerPerformance,
            element: <ManagerDesignerPerformance />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_ManagerMillingPerformance,
            element: <ManagerMillingPerformance />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_ManagerDispatchOverview,
            element: <ManagerDispatchOverview />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_ManagerstlPreview,
            element: <ManagerstlPreview />,
          },
          {
            path: ROUTES.CENTRAL.Manager.MANAGER_ManagerMillingResourceOverview,
            element: <ManagerMillingResourceOverview />,
          },
          {
            path: ROUTES.CENTRAL.Manager.ManagerRejectedOrder,
            element: <ManagerRejectedOrder />,
          },
           {
            path: ROUTES.CENTRAL.Manager.ManagerTicket,
            element: <ReplyRaiseTicket />},
             {
            path: ROUTES.CENTRAL.Manager.ManagerSLABreachMonitor,
            element: <ManagerSLABreachMonitor />,},
                {
            path: ROUTES.CENTRAL.Manager.ManagerContactSupport,
            element: <ManagerContactSupport />,},
             {
            path: ROUTES.CENTRAL.Manager.RealtimeOrderTracking,
            element: <RealtimeOrderTracking />,},

            {
            path: ROUTES.CENTRAL.Manager.ManagerWarrantyClaimResponse,
            element: <ManagerWarrantyClaimResponse />,}
            
            
        
        ],
      },
    ],
  },
];